import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import { hot } from 'react-hot-loader';

const useStyles = makeStyles({
	root: {
		// width: 200,
		display: 'flex',
		alignItems: 'center',
		// marginLeft: '30%',
		// marginRight: '50%',
		fontSize: '20px'
	},
	summary: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		fontSize: '18px'
	}
});

export default hot(module)(function RatingStars(props) {
	const classes = useStyles();

	return (
		<div className={classes.summary}>
			<Rating
				name="hover-feedback"
				value={Number(props.stars)}
				precision={0.1}
				disabled
				style={{ opacity: 1, fontSize: '20px' }}
			/>
		</div>
	);
});
